<template>
  <v-form ref="form">
    <v-card>
      <v-card-text class="operator-form__content">
        <div class="title text--primary">
          Terms of purchase
        </div>
        <v-alert
          v-if="!ownOperator.terms_custom"
          type="info"
          outlined
          class="mt-4"
        >
          Enable custom purchasing terms to edit
        </v-alert>
        <v-textarea
          v-model="ownOperator.terms_text"
          :readonly="!ownOperator.terms_custom"
          value="Terms of purchase text."
        ></v-textarea>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed @click.stop="closeDialog">Close</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<style>
.v-textarea textarea[readonly="readonly"] {
    background-color: #f0f0f0;
    color: gray;
}
</style>

<script>
export default {
  props: ['ownOperator'],
  data: function () {
    return {
      typeOf: typeof this.ownOperator
    }
  },
  computed: {
  },
  methods: {
    closeDialog () {
      this.$emit('close-terms-form');
    }
  },
  mounted () {
  },
  components: {
  }
}
</script>
